import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { SbeUploadEvent, FileService, SbeUploadEventTypes } from '@schoolbelle/api/file';
import { filter, map, tap } from 'rxjs/operators';
import { takeWhileInclusive } from 'rxjs-take-while-inclusive';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-log',
  templateUrl: './log.component.html',
  styleUrls: ['./log.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class FileUploadListLogComponent implements OnInit {
  @Input('id') id:any;
  list:SbeUploadEvent[] = [];
  constructor(
    private file:FileService,
    private cdRef:ChangeDetectorRef,
  ) { }

  subscription = new Subscription();
  ngOnInit() {
    this.subscription.add(
      this.file.events.pipe(
        filter(e=>e.id === this.id), 
        map(e=>e.event),
        takeWhileInclusive(e=>e.type !== SbeUploadEventTypes.FileInfo && e.type !== SbeUploadEventTypes.UploadError),
        tap(e=>this.list.push(e)),
      ).subscribe(()=>{
        this.cdRef.detectChanges();
      })
    );
  }
  ngOnDestroy () {
    this.subscription.unsubscribe();
  }
  trackByIndex(index) {
    return index;
  }

}
